export default __webpack_public_path__ + "static/media/instructions-tip.22624d2f.svg";